import { DeliveryTerminalResponse, OrderProductDetails, Payment, UserAddress } from './api.models';
import { OrderMetaData, OrderStatus } from './order-info.model';

export interface UserOrderStatus {
  id: number;
  name: string;
  statusName: OrderStatus;
  languageName: string;
  prev: OrderStatus[];
  next: OrderStatus[];
  image: string;
}

export interface UserOrder {
  id: string;
  orderShortId: string;
  createdDate: string;
  deliveryType: DeliveryType;
  orderProducts: OrderProductDetails[];
  comment: string;
  userAddress: UserAddress;
  payment: Payment;
  estimatedDeliveryTime: string;
  deliveryDate: string | null;
  deliveryTerminal: DeliveryTerminalResponse;
  metaData: OrderMetaData;
  status: UserOrderStatus;
  /**
   * У нас 4 статуса. В зависимости от того, как пройден каждый статус имеем:
   * null - этот этап ещё не начат,
   * false - это текущий этап, он не завершён,
   * true - это завершённый этап,
   * Если массив пустой, то вообще не показываем статусы и считаем, что это какой-то ошибочный статус
   */
  passedSteps: (boolean | null)[];
}

export enum DeliveryType {
  PICKUP = 'PICKUP',
  DELIVERY = 'DELIVERY'
}
